import { useContext, createContext } from 'react';
export var configurationContext = /*#__PURE__*/createContext({
  globalApiUrl: '',
  mobileOfficeApiUrl: '',
  staticApiUrl: '',
  tenant: '',
  customerId: 0,
  lang: ''
});
export var ConfigurationProvider = configurationContext.Provider;
export var useConfiguration = function useConfiguration() {
  return useContext(configurationContext);
};